import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from "./auth-guard.service";

const routes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes
    )
  ],
  providers: [ AuthGuard ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/app-routing.module.ts